import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/logo.png';
var _hoisted_1 = {
  class: "outer-container-header"
};
var _hoisted_2 = {
  class: "container-fluid long-container"
};
var _hoisted_3 = {
  class: "container"
};
var _hoisted_4 = {
  class: "navbar navbar-default long-header"
};
var _hoisted_5 = {
  class: "container-fluid long-nav"
};
var _hoisted_6 = {
  class: "navbar-header"
};

var _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1);

var _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon-bar"
}, null, -1);

var _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon-bar"
}, null, -1);

var _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon-bar"
}, null, -1);

var _hoisted_11 = [_hoisted_8, _hoisted_9, _hoisted_10];
var _hoisted_12 = {
  class: "collapse navbar-collapse",
  id: "bs-example-navbar-collapse-1"
};
var _hoisted_13 = {
  class: "nav navbar-nav navbar-right long-nav-font"
};

var _hoisted_14 = /*#__PURE__*/_createTextVNode("首页 ");

var _hoisted_15 = /*#__PURE__*/_createTextVNode("献血知识");

var _hoisted_16 = /*#__PURE__*/_createTextVNode("新闻资讯");

var _hoisted_17 = /*#__PURE__*/_createTextVNode("联系我们");

var _hoisted_18 = {
  class: "mobile-nav"
};

var _hoisted_19 = /*#__PURE__*/_createTextVNode("首页");

var _hoisted_20 = /*#__PURE__*/_createTextVNode("献血知识");

var _hoisted_21 = /*#__PURE__*/_createTextVNode("新闻动态");

var _hoisted_22 = /*#__PURE__*/_createTextVNode("联系我们");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("nav", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_Transition, {
    name: "logo",
    appear: "",
    class: "animate__animated",
    "enter-active-class": "animate__backInDown"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_router_link, {
        class: "navbar-brand logo",
        to: "/home"
      }, {
        default: _withCtx(function () {
          return [_hoisted_7];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createElementVNode("button", {
    type: "button",
    class: "navbar-toggle long-collapsed",
    onClick: _cache[0] || (_cache[0] = function () {
      return $setup.changeMobileList && $setup.changeMobileList.apply($setup, arguments);
    })
  }, [_createElementVNode("div", {
    class: _normalizeClass({
      'bar-hover': $setup.showMobileList,
      'bar-unhover': !$setup.showMobileList
    })
  }, _hoisted_11, 2)])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("ul", _hoisted_13, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
    "active-class": "long-liHover",
    to: "/home"
  }, {
    default: _withCtx(function () {
      return [_hoisted_14];
    }),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    "active-class": "long-liHover",
    to: "/knowledge"
  }, {
    default: _withCtx(function () {
      return [_hoisted_15];
    }),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    "active-class": "long-liHover",
    to: "/news"
  }, {
    default: _withCtx(function () {
      return [_hoisted_16];
    }),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    "active-class": "long-liHover",
    to: "/contact"
  }, {
    default: _withCtx(function () {
      return [_hoisted_17];
    }),
    _: 1
  })])])])])])])])]), _createVNode(_Transition, {
    name: "mobileNav"
  }, {
    default: _withCtx(function () {
      return [_withDirectives(_createElementVNode("div", _hoisted_18, [_createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/home",
        "active-class": "mobile-nav-hover",
        onClick: $setup.navRouterJump
      }, {
        default: _withCtx(function () {
          return [_hoisted_19];
        }),
        _: 1
      }, 8, ["onClick"])]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/knowledge",
        "active-class": "mobile-nav-hover",
        onClick: $setup.navRouterJump
      }, {
        default: _withCtx(function () {
          return [_hoisted_20];
        }),
        _: 1
      }, 8, ["onClick"])]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/news",
        "active-class": "mobile-nav-hover",
        onClick: $setup.navRouterJump
      }, {
        default: _withCtx(function () {
          return [_hoisted_21];
        }),
        _: 1
      }, 8, ["onClick"])]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/contact",
        "active-class": "mobile-nav-hover",
        onClick: $setup.navRouterJump
      }, {
        default: _withCtx(function () {
          return [_hoisted_22];
        }),
        _: 1
      }, 8, ["onClick"])])])], 512), [[_vShow, $setup.showMobileList]])];
    }),
    _: 1
  })], 64);
}